// components/CalendlyModal.jsx
import React from 'react';
import { PopupModal } from 'react-calendly';
import './CalendlyModal.css';

const CalendlyModal = ({ open, onClose }) => {
  return (
    <div>
      <PopupModal
        url="https://calendly.com/shynegraphicscorp/"
        onModalClose={onClose}
        open={open}
        rootElement={document.getElementById('root')}
      />
    </div>
  );
};

export default CalendlyModal;
